import axios from "axios";
import React, { useState, useEffect, useCallback } from "react";
import { _serverUrl, _serverUrl2 } from "../../../config";
import { useHistory, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { MySwal, failed, success } from "../../../Utils/Alerts2";
import ReactModal from "react-modal";
import { useSelector } from "react-redux";

export default function ProjectInfo() {
  const getUserInfo = useSelector((state) => state.getUserInfo);
  const history = useHistory();
  const taskId = useParams().id;
  const [puanAnaliz, setPuanAnaliz] = useState([]);
  const [veriler, setVeriler] = useState([]);
  const [optionsGetir, setOptionsGetir] = useState([]);
  const [sablonJSON, setSablonJSON] = useState({ sablon_json: "[]" });
  const [showPopup, setShowPopup] = useState(false);
  const [showImg, setShowImg] = useState(false);
  const [foto, setFoto] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedOptions, setSelectedOptions] = useState({}); // Store selected options in an object
  const [textArea, setTextArea] = useState({});
  const [noneSelectedOptions, setNoneSelectedOptions] = useState({});
  const [sablonId, setSablonId] = useState({});
  console.log(getUserInfo, "kullanıcı Bilgiler");

  const getPuanAnalizi = useCallback(async () => {
    await axios.get(_serverUrl2 + "/projects/BinaPuanHesaplama/" + taskId).then((res) => {
      console.log(res, "res");
      setPuanAnaliz(res.data.rows);
    });
  }, [taskId]);

  const getFoto = useCallback(async () => {
    try {
      const response = await axios.get(_serverUrl2 + "/projects/getFoto/" + taskId);
      const fotoList = response.data.rows.reduce((acc, current) => {
        const tur = current.tur;
        if (!acc[tur]) {
          acc[tur] = [];
        }
        acc[tur].push({
          ...current,
          fullURL: _serverUrl + "/images/" + current.foto_path,
        });
        return acc;
      }, {});
      setFoto(fotoList);
    } catch (error) {
      console.log(error);
    }
  }, [taskId]);

  const openPopup = (image) => {
    setSelectedImage(image);
    setShowPopup(true);
  };

  const sablonGetir = async () => {
    await axios.get(_serverUrl2 + "/projects/getAllSablonlar").then((res) => {
      console.log(res.data.rows, "sablon");
      setOptionsGetir(res.data.rows.filter((x) => x.proje_id == 1));
    });
  };

  const openPopupInfo = async () => {
    try {
      const response = await axios.get(_serverUrl2 + "/projects/BinaPuanHesaplamaDetay/" + taskId);
      const bilgiler = response.data.rows;
      console.log(bilgiler, "bilgiler");
      MySwal.fire({
        html: (
          <div>
            <table className="table table-sm table-bordered table-hover table-striped">
              <tbody>
                {bilgiler.map((d, i) => (
                  <tr key={i}>
                    <td style={{ display: "flex", justifyContent: "space-between" }}>
                      <div>{d.Ad}</div>
                      <div>{d.Puan}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ),
        buttons: {
          confirm: {
            text: "Tamam",
            value: true,
            visible: true,
            className: "btn-primary",
            closeModal: true,
          },
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const closePopup = () => {
    setSelectedImage("");
    setShowPopup(false);
  };

  const getVeriler = useCallback(async () => {
    await axios.get(_serverUrl2 + "/projects/projeBilgileri/" + taskId).then((res) => {
      setVeriler(res.data.rows);
      console.log(res.data.rows, "kkk");

      let v = {};
      res.data.rows.map((d, i) => {
        return (v[d.label] = d.value);
      });
      setSelectedOptions(v);
      setTextArea(v);
      setNoneSelectedOptions(v);

      console.log(res.data.rows, "verileri getir daaa");
      if (res.data.rows.length !== 0) {
        axios.get(_serverUrl2 + "/projects/getSablonData/" + res.data.rows[0].sablon_id).then((res2) => {
          console.log("res.asdasdaaregargsd.rows[0]", res2.data.rows[0].sablon_json);
          setSablonJSON(res2.data.rows[0]);
          setSablonId(sablonJSON.id);
          // setSelectedOptions(res.data.rows)
        });
      }
    });
  }, [taskId, sablonJSON.id]);

  const onChangeTip = async (e) => {
    const selectedValue = e.target.value; // Seçilen değeri al

    if (sablonId == parseInt(selectedValue)) {
      getVeriler();
    } else {
      console.log(optionsGetir.filter((x) => x.id == selectedValue)[0], "seelll");
      Swal.fire({
        title: "Bina Tipi Değiştirme Onayı",
        text: "Bina Tipi seçimini değiştirmek istediğinizden emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Evet, Değiştir",
        cancelButtonText: "Hayır, Vazgeç",
      }).then((result) => {
        if (result.isConfirmed) {
          setSablonJSON(optionsGetir.filter((x) => x.id == selectedValue)[0]);

          let json = {
            sablon_id: selectedValue,
            gorev_id: taskId,
          };
          axios.post(_serverUrl2 + "/projects/NewProjeBilgileri", json).then((res) => {
            setVeriler(res.data.rows);
            console.log(res.data.rows, "eee");

            let v = {};
            res.data.rows.map((d, i) => {
              return (v[d.label] = d.value);
            });
            setSelectedOptions(v);
            setTextArea(v);
            setNoneSelectedOptions(v);
          });
        } else {
          // Kullanıcı iptal ederse veya "Hayır"ı seçerse tipi seçimini değiştirmeyin.
        }
      });
    }
  };

  const onClickTenrarGonder = async () => {
    console.log(taskId);
    MySwal.fire({
      title: "Kontrole Gönderme Nedeni",
      height: "50%",
      html: (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <center>
                <table className="table table-sm " style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td>Not :</td>
                      <td>
                        <textarea id="tekrarNot" style={{ minWidth: "300px", maxWidth: "250x" }}></textarea>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </center>
            </div>
          </div>
        </div>
      ),
      confirmButtonText: "Kaydet",
      showConfirmButton: true,
      showCloseButton: true,
      showCancelButton: false,
    }).then((result) => {
      if (result.isConfirmed) {
        if (document.getElementById("tekrarNot").value == "") {
          return failed("Not Kısmı Boş Bırakılamaz");
        }
        let json = {
          gorevid: taskId,
          not: document.getElementById("tekrarNot").value,
        };
        console.log("not", json);

        axios
          .post(_serverUrl2 + "/projects/TekrarKontroleGonder", json)
          .then((res) => {
            if (res.status) {
              success("Not Kaydedildi.");
            }
          })
          .catch((eror) => {
            failed("Not Eklenirken Hata Oluştu " + eror);
          });
      }
    });
  };
  const guncelleKaydet = async () => {
    let json = {
      gorev: { nl_id: taskId, userid: getUserInfo.Id, sablon_id: sablonJSON.id, bina_not: document.getElementById("guncellemeNot").value },
      values: selectedOptions,
    };
    console.log("zthzrh", json);

    axios
      .post(_serverUrl2 + "/projects/getUpdateValuesProject", json)
      .then((res) => {
        if (res.status) {
          success("Not Kaydedildi.");
        }
        console.log(res.data);
      })

      .catch((eror) => {
        failed("Not Eklenirken Hata Oluştu " + eror);
      });
  };
  const onClickGuncelle = async () => {
    console.log("getUserInfo", getUserInfo);

    MySwal.fire({
      title: "Güncelleme Nedeni",
      height: "50%",
      html: (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <center>
                <table className="table table-sm " style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td>Not :</td>
                      <td>
                        <textarea id="guncellemeNot" style={{ minWidth: "350px", maxWidth: "250x" }}></textarea>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </center>
            </div>
          </div>
        </div>
      ),
      confirmButtonText: "Kaydet",
      showConfirmButton: true,
      showCloseButton: true,
      showCancelButton: false,
    }).then((result) => {
      if (result.isConfirmed) {
        if (document.getElementById("guncellemeNot").value == "") {
          return failed("Not Kısmı Boş Bırakılamaz");
        }
        guncelleKaydet();
      }
    });
  };

  const changeSelected = (e, selectId) => {
    const newSelectedValue = e.target.value;
    // Use the selectId to identify which select element triggered the change
    console.log(`Selected option for ${selectId}: ${newSelectedValue}`);
    setSelectedOptions((prevState) => ({
      ...prevState,
      [selectId]: newSelectedValue,
    }));
    setTextArea((prevState) => ({
      ...prevState,
      [selectId]: newSelectedValue,
    }));
    setNoneSelectedOptions((prevState) => ({
      ...prevState,
      [selectId]: newSelectedValue,
    }));
  };

  useEffect(() => {
    getFoto();
    getPuanAnalizi();
    getVeriler();
    sablonGetir();

    return () => {};
  }, [taskId, getFoto, getPuanAnalizi, getVeriler]);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div>
          <div className="content d-flex justify-content-between">
            <button className="orangeBtn" style={{ fontSize: "13px", width: "30px" }} onClick={() => history.goBack()}>
              <i className="fas fa-arrow-left"></i>
            </button>
            <b>Görev Bilgileri</b>
            <b>&nbsp;</b>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12" style={{ marginBottom: "5px" }}>
          <div className="row">
            <div className="col-5" style={{ marginTop: "2px" }}>
              <button onClick={() => setShowImg(!showImg)} className={`btn btn-sm ${showImg ? "btn-success" : "btn-danger"} form-control`} style={{ color: "white" }}>
                {showImg ? "Bilgiler" : "Resimler"}
              </button>
            </div>
            <div className="col-6" style={{ marginTop: "2px", backgroundColor: "#344E75", borderRadius: "5px", color: "white", textAlign: "center" }}>
              Puan Analizi: {puanAnaliz}
            </div>
            <div className="col-1" style={{ marginTop: "2px", display: "flex", justifyContent: "center" }}>
              <button id="infobtn" className="btn btn-sm btn-info form-control" onClick={openPopupInfo}>
                <i className="fas fa-info"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {showImg === false ? (
        <>
          {console.log("sablonJSON", sablonJSON)}
          {veriler.length !== 0 ? (
            JSON.parse(sablonJSON.sablon_json).map((d, i) => {
              const selectId = d.label; // Generate a unique ID for each select element
              return (
                <div key={i} className="row">
                  {i == 0 ? (
                    <>
                      <div className="col-8">
                        <span style={{ fontWeight: "bold" }}>Görevli Kişiler :</span>
                        <br />
                        {veriler[0].gorevli_kisiler}
                      </div>
                      <div className="col-4">
                        <span style={{ fontWeight: "bold" }}>Maks Kimlik No:</span>
                        <br />
                        {veriler[0].maks_kn}
                      </div>
                      <div className="col-12">
                        <hr></hr>
                      </div>
                      {getUserInfo.Rol.includes("15") ? (
                        <div className="col-6">
                          {veriler[0].gorev_durum}

                          <div style={{ width: "400px", marginTop: "15px" }}>
                            <p>NOT : {veriler[0].bina_not}</p>{" "}
                          </div>
                        </div>
                      ) : (
                        <div className="col-12">{veriler[0].gorev_durum}</div>
                      )}
                      {getUserInfo.Rol.includes("15") ? (
                        <div className="col-6" style={{ marginBottom: "5px", height: "60px" }}>
                          {veriler[0].gorev_durum == "TEKRAR KONTROL" ? (
                            ""
                          ) : (
                            <button className="redBtn" style={{ minWidth: "100px" }} onClick={() => onClickTenrarGonder()}>
                              Tekrar Kontrole Gönder{" "}
                            </button>
                          )}
                        </div>
                      ) : null}
                    </>
                  ) : (
                    <div></div>
                  )}
                  {i == 0 ? (
                    <>
                      <div className="col-5" style={{ backgroundColor: "#C0DBEA", borderRadius: "2px", marginBottom: "2px", fontWeight: "bold" }}>
                        <label>TİPİ</label>
                      </div>
                      <div className="col-7">
                        <select
                          id={selectId} // Use the unique ID for each select element
                          className="form-control form-select"
                          // Get the selected value from the state
                          onChange={onChangeTip} // Pass the unique ID as a parameter
                          value={sablonJSON.id}
                        >
                          {optionsGetir.map((option, i) => (
                            <option key={i} value={option.id}>
                              {option.sablon_adi}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  ) : null}
                  <div className="col-5" style={{ backgroundColor: "#C0DBEA", borderRadius: "2px", marginBottom: "2px", fontWeight: "bold" }}>
                    <label>{d.label + ":"}</label>
                  </div>
                  <div className="col-7">
                    {console.log(veriler, d.label, d.type, veriler.filter((z) => z.label == d.label).length)}
                    {d.type === "COMBOBOX" && veriler.filter((z) => z.label == d.label).length != 0 ? (
                      <select
                        id={selectId} // Use the unique ID for each select element
                        className="form-control form-select"
                        value={selectedOptions[selectId] || ""} // Get the selected value from the state
                        onChange={(e) => changeSelected(e, d.label)} // Pass the unique ID as a parameter
                      >
                        <option selected disabled value="-">
                          Seçilmedi
                        </option>
                        {d.options.map((option, i) => (
                          <option key={i} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    ) : d.type === "COMBOBOX" ? (
                      <select
                        id={selectId} // Use the unique ID for each select element
                        className="form-control form-select"
                        value={noneSelectedOptions[selectId] || "-"}
                        onChange={(e) => changeSelected(e, d.label)} // Pass the unique ID as a parameter
                      >
                        <option selected disabled value="-">
                          Seçilmedi
                        </option>
                        {d.options.map((option, i) => (
                          <option key={i} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <textarea
                        className="form-control"
                        type="text"
                        value={textArea[selectId] || ""}
                        style={{ borderRadius: "5px", height: "50px", minHeight: "55px" }}
                        onChange={(e) => changeSelected(e, d.label)} // Pass the unique ID as a parameter
                      />
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-sm-12">
              <div>Eklenmiş bir bilgi yok.</div>
            </div>
          )}
        </>
      ) : (
        <>
          <div className="col-12">
            <div className="row">
              {Object.entries(foto).map(([tur, fotoList]) => (
                <div key={tur} className="col-12">
                  <div className="row">
                    <div
                      className="col-12"
                      style={{ backgroundColor: "#025464", marginTop: "2px", borderRadius: "5px", marginLeft: "10px", textAlign: "center", color: "wheat" }}
                    >
                      {tur}
                    </div>
                    {fotoList.map((d, i) => (
                      <div className="col-3">
                        <div className="row">
                          <div key={i}>
                            <div className="row">
                              <div>
                                <img
                                  style={{ marginLeft: "2px", marginTop: "3px", border: "2px solid black", borderRadius: "4px" }}
                                  src={d.fullURL}
                                  alt="gorevFoto"
                                  width={"100px"}
                                  height={"100px"}
                                  onClick={() => openPopup(d.fullURL)}
                                ></img>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </>
      )}

      {/* Fotoğraf Zoom PopUp için yapılan yer */}
      {showPopup && (
        <ReactModal
          isOpen={showPopup}
          onRequestClose={closePopup}
          ariaHideApp={false}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9999,
            },
            content: {
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "5px",
              maxWidth: "100%", // Önceki değer: '80%'
              maxHeight: "100%", // Önceki değer: '80%'
              width: "80%",
              height: "80%",
              overflow: "auto",
            },
          }}
        >
          <div>
            <img src={selectedImage} alt="zoomedFoto" style={{ width: "100%", height: "auto" }} />
          </div>
        </ReactModal>
      )}
      {getUserInfo.Rol.includes("15") ? (
        <button style={{ width: "40%", marginLeft: "50%", marginTop: "1%", marginBottom: "2%" }} className="btn btn-warning" onClick={() => onClickGuncelle()}>
          Güncelle
        </button>
      ) : null}
    </div>
  );
}
